import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { buildUrlAndOpenSameWindow } from '../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../Config';
import { isMobile } from 'react-device-detect';
import { getReportParams, report } from '../../../middleware/report';
import { isOrgEmployeeLogin } from '../OTPLoginBlock/Assets/variables';
const SupportWorlds = (props) => {
    const isOrgEmployee = isOrgEmployeeLogin(props.authentication);
    const backgroundImageWeb = 'url(' + Config.epiBaseUrl + props.iContent.backgroundImageWeb?.expandedValue?.url + ')';
    const backgroundImageMobile = 'url(' + Config.epiBaseUrl + props.iContent.backgroundImageMobile?.expandedValue?.url + ')';
    const paddingBottomWeb = props.iContent.paddingBottomWeb?.value;
    const paddingBottomMobile = props.iContent.paddingBottomMobile?.value;
    const productToRender = props.benefitsAllocations || props.componentProps?.productToRender || {};
    
    const filteredSupportWorlds = props.iContent.supportWorlds?.expandedValue?.filter((item) => {
        if (!isOrgEmployee) {
            return true;
        }
        const productType = item.productType?.value;
        return productToRender?.hasOwnProperty(productType?.toLowerCase());
    }) || [];

    const style = { 
        backgroundImage: isMobile ? backgroundImageMobile : backgroundImageWeb,
        paddingBottom: isMobile ? paddingBottomMobile : paddingBottomWeb
    }

    useEffect(() => {
        reportDWH({ actionType: 'SupportCenterMainPage', status: 'Ongoing', messageText: 'SupportCenterMainPage Displayed' });
    }, []);

    const isDisabled =(x) => { return isOrgEmployee &&  productToRender?.[x?.productType?.value?.toLowerCase()]?.remaining < 1 }

    return (
        filteredSupportWorlds.length > 0 &&
        <div className='support-worlds-block' style={style}>
            <div className='support-worlds'>
                {
                    props.iContent.title?.value &&
                    <div className='title'> {props.iContent.title?.value} </div>
                }

                {
                    props.iContent.subTitle?.value &&
                    <div className='sub-title'> {props.iContent.subTitle?.value} </div>
                }

                    <div className='worlds-wrapper'>
                    {
                        
                        [...(filteredSupportWorlds || [])]
                            .sort((a, b) => {
                                const aDisabled = isDisabled(a);
                                const bDisabled = isDisabled(b);
                                return aDisabled - bDisabled;
                            })
                            .map((item, index) => {    
                            const disabled = isDisabled(item);
                            return (
                                <a key={index} className={`world-item ${disabled ? 'disabled' : ''}`} href='#' onClick={(e) => handleWorldClick(e, item)}>
                                    {
                                        item.tagText?.value &&
                                        <div className='world-tag' style={{ backgroundColor: item.tagBackgroundColor?.value, color: item.tagTextColor?.value }}> {item.tagText?.value} </div>
                                    }
                                    {
                                        item?.worldImage?.expandedValue &&
                                        <Image className='world-image' src={Config.epiBaseUrl + item?.worldImage?.expandedValue?.url} alt={item.worldName?.value} />
                                    }                                
                                    <span className='world-name'> {item.worldName?.value} </span>
                                    {disabled && <span className='no-product-remaining'> ההטבה מומשה </span>}
                                </a>
                            );
                        })
                    }
                </div>

            </div>
        </div>
    );

    function reportDWH(params) {
        const isAuthenticated = props.loginData?.isFullAuthenticated || props.loginData?.isOtpAuthenticated || props.loginData?.isOtpExtendedAuthenticated || props.loginData?.isSilentOtpAuthenticated;

        let reportParams = getReportParams();
        reportParams.area = 'Support';
        reportParams.subArea = 'SupportCenter';
        reportParams.channel = 'WebsitePrivate';
        reportParams.actionType = params.actionType;
        reportParams.status = params.status;
        reportParams.messageText = params.messageText;
        reportParams.customerName = isAuthenticated ? `${props.loginData?.userDetails?.firstName} ${props.loginData?.userDetails?.lastName}` : '';
        reportParams.email = '';
        reportParams.banId = '';
        reportParams.idNumber = props.loginData?.userDetails?.IDNumber ?? '';
        reportParams.subscriber = props.loginData?.userDetails?.contactNumber ?? '';
        reportParams.param1 = props.iContent.title?.value;
        reportParams.param9 = isAuthenticated ? (props.loginData?.userDetails?.IsPrimaryContact ? 'איש קשר' : 'מנוי') : ''
        reportParams.param10 = props.loginData?.isFullAuthenticated ? 'לקוח' : props.loginData?.isOtpExtendedAuthenticated ? 'OTP מורחב' : props.loginData?.isOtpAuthenticated ? 'OTP' : '';
        report(reportParams);
    }

    function handleWorldClick(e, item) {
        e.preventDefault();
        buildUrlAndOpenSameWindow(item.worldUrl?.value);      
    }

};

const mapStateToProps = (state) => {
    return {
        loginData: state.authentication.loginData,
        authentication: state.authentication,
        benefitsAllocations: state.orgEmployeeFamilySale.benefitsAllocations,
    };
};

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(SupportWorlds);
